module.exports = __webpack_public_path__ + "img/86ef881.png";